import React from 'react';
import { Typography, Box } from '@mui/material';

const ExpiryTypo = ({ dateString, remainingDays, variant = 'caption' }) => {
  const getExpiryInfo = (remainingDays) => {
    if (remainingDays < 0) {
      return {
        label: 'EXPIRED: ',
        color: 'error',
        fontWeight: 'bold'
      };
    } else if (remainingDays <= 7) {
      return {
        label: 'EXPIRES SOON: ',
        color: 'warning',
        fontWeight: 'bold'
      };
    } else {
      return {
        label: 'Expires: ',
        color: 'text.secondary',
        fontWeight: 'normal'
      };
    }
  };

  const expiryInfo = getExpiryInfo(remainingDays);

  return (
    <Typography 
      variant={variant}
      color={expiryInfo.color}
      sx={{ 
        fontWeight: expiryInfo.fontWeight,
        display: 'block'
      }}
    >
      {expiryInfo.label}{dateString}
    </Typography>
  );
};

export default ExpiryTypo; 